export interface SessionTokens {
  access_token: string;
  refresh_token?: string;
}

const REFRESH_TOKEN_KEY = 'refresh_token';
const LEGACY_LOCAL_STORAGE_KEYS = ['token', 'refresh_token'];

// El access token vive solo en memoria (closure del módulo): no se persiste ni se expone en window.
let accessToken: string | null = null;

const readRefreshToken = (): string | null => {
  try {
    return sessionStorage.getItem(REFRESH_TOKEN_KEY);
  } catch {
    return null;
  }
};

const writeRefreshToken = (token: string) => {
  try {
    sessionStorage.setItem(REFRESH_TOKEN_KEY, token);
  } catch {
    // Sin sessionStorage la sesión dura solo mientras la pestaña no se recargue.
  }
};

const removeRefreshToken = () => {
  try {
    sessionStorage.removeItem(REFRESH_TOKEN_KEY);
  } catch {
    // Nada que limpiar si el storage no está disponible.
  }
};

export class JwtService {
  static getJwt(): string | null {
    return accessToken;
  }

  static saveJwt(token: string) {
    accessToken = token;
  }

  static getRefreshToken(): string | null {
    return readRefreshToken();
  }

  static saveSession({ access_token, refresh_token }: SessionTokens) {
    JwtService.saveJwt(access_token);
    if (refresh_token) {
      writeRefreshToken(refresh_token);
    }
  }

  static purgeLegacyStorage() {
    try {
      LEGACY_LOCAL_STORAGE_KEYS.forEach(key => localStorage.removeItem(key));
    } catch {
      // Nada que limpiar si el storage no está disponible.
    }
  }

  static clear() {
    accessToken = null;
    removeRefreshToken();
    JwtService.purgeLegacyStorage();
  }
}
